export const linkStyle = {
  textDecoration: 'none',
  color: 'black',
};
